import React, { Suspense, useEffect } from "react";

import { ErrorBoundary } from "react-error-boundary";
import ScrollToTop from "react-scroll-to-top";
import ArrowUpwardRoundedIcon from "@mui/icons-material/ArrowUpwardRounded";

import moment from "moment";

import { Loading, ErrorFallback } from "./components";
import { Router } from "./routes/Router";

import "./styles/app.scss";
import "react-phone-number-input/style.css";
import "react-phone-input-2/lib/style.css";


export function App(): JSX.Element {
  useEffect(
    () => {
      const latestAccessTimeString = localStorage.getItem("accessTime");
      const latestAccessTime = moment(latestAccessTimeString);

      if (moment().diff(latestAccessTime, "minutes") >= 1) {
        localStorage.setItem("accessTime", moment().format());
      }
    },
    []
  );

  return (
    <Suspense fallback={<Loading />}>
      {/*loading action when api error*/}
      {/*<ErrorBoundary FallbackComponent={ErrorFallback}>{loading ? <Loading /> : <AppRoutes />}</ErrorBoundary>*/}
      {/* @ts-ignore */}
      <ScrollToTop
        style={{
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        smooth
        component={<ArrowUpwardRoundedIcon />}
      />
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <Router />
      </ErrorBoundary>
    </Suspense>
  );
}
